module.exports = __webpack_public_path__ + "static/media/step1.34b96460.svg";